import { Component, Inject } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface CloseBidDialogData {
  project_name?: string;
  boq_code?: string;
}

@Component({
  selector: 'app-close-bid-dialog',
  templateUrl: './close-bid-dialog.component.html',
  styleUrls: ['./close-bid-dialog.component.css']
})
export class CloseBidDialogComponent {
  form = new FormGroup({
    comments: new FormControl<string>('')
  });

  constructor(
    public dialogRef: MatDialogRef<CloseBidDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: CloseBidDialogData
  ) {}

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    const comments = (this.form.value.comments || '').trim() || undefined;
    this.dialogRef.close({ comments });
  }
}
